import {notiDeleteAction, notiMarkReadAction, notiResponseAction} from 'module/Noti/action/NotiAction';
import {combineReducers} from 'redux';
import _ from 'lodash'
import {notiDrawerOpenAction} from 'module/Noti/action/NotiDrawerAction';
import {Noti} from 'generated/JavaTOmodifications';
import {createReducer} from 'util/redux';

const byId = createReducer<{ [id in number]: Noti }>({}, builder => builder
	.addCase(notiResponseAction, (state, {payload}) => {
		const s = _.keyBy(payload, 'id');
		if (_.isEqual(state, s)) return state
		return s;
	})
	.addCase(notiMarkReadAction, (state, {payload}) => {
		const {id, read} = payload
		return {
			...state,
			[id]: {
				...state[id],
				read,
			},
		}
	})
	.addCase(notiDeleteAction, (state, {payload}) => _.omit(state, payload)),
)

const allIds = createReducer<number[]>([], builder => builder
	.addCase(notiResponseAction, (state, {payload}) => {
		const s = _.map(payload, 'id')
		if (_.isEqual(state, s)) return state
		return s;
	})
	.addCase(notiDeleteAction, (state, {payload}) => state.filter(x => x !== payload)),
)

const open = createReducer<boolean>(false, builder => builder
	.addCase(notiDrawerOpenAction, (state, {payload}) => payload),
)

export const NotiReducerNS = {Noti: combineReducers({byId, allIds, open})}
export type NotiStateType = { Noti: ReturnType<typeof NotiReducerNS.Noti> }